import nls from '../../../../nls/pt-BR.json';
import { useTypedSelector } from '../../../../../../../hooks/useTypedSelector';
import {
  setCanAdvance,
  studiesSelector,
} from '../../../../redux/studies.reducer';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { DisplayChartsKeys } from '../../../../../charts/types';
import {
  clearMap,
  removeClusters,
  removeMarkers,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
} from '../../../../../redux/dashboardActions';
import { Map } from 'eemovel-map-library';
import { PolygonType } from '../../../../redux/studies.model';

const drawPolygon = (polygon: PolygonType) => {
  if (polygon instanceof google.maps.Circle) {
    const circle = new google.maps.Circle({
      center: polygon.getCenter(),
      radius: polygon.getRadius(),
      fillColor: '#000',
    });
    circle.setMap(Map.map);
    Map.markerCircle = circle;
    return;
  }
  const coords = polygon?.getPath().getArray();
  const newPolygon = new google.maps.Polygon({
    paths: coords,
    fillColor: '#000',
  });
  newPolygon.setMap(Map.map);
  Map.PoligonOnMap = newPolygon;
  return;
};

export const UnderstandTransactions: React.FC = () => {
  const displayCharts: DisplayChartsKeys = useTypedSelector(
    (state) => state.dashboardState.displayCharts
  );
  const { polygon } = useTypedSelector(studiesSelector);
  const { bigNumbers } = useTypedSelector((state) => state.bigNumbersState);
  const dispatch = useDispatch();
  const [displayHeatmap, setDisplayHeatmap] = useState<boolean>(true);
  useEffect(() => {
    dispatch([
      setIsActive({ name: 'menuAction', value: '3' }),
      setIsActiveRightSidebar({ name: 'menuAction', value: '2' }),
      setDisplayCharts(null),
      removeMarkers(),
      removeClusters(),
    ]);
    dispatch(clearMap());
    drawPolygon(polygon);
  }, []);
  useEffect(() => {
    if (displayCharts === 'transactions') {
      dispatch(setCanAdvance(true));
    }
  }, [displayCharts]);
  return (
    <>
      <p className="helper-text">{nls.studyCreationGuide.steps.step6.helper}</p>
      {/* Comentado até a implementação dos mapas de calor */}
      {/* <Checkbox
        label={
          <span style={{ fontSize: 12, fontFamily: 'Open Sans, sans-serif' }}>
            {nls.studyCreationGuide.steps.step6.includeHeatmap}
          </span>
        }
        checked={displayHeatmap}
        action={() => setDisplayHeatmap(!displayHeatmap)}
        cy="Step6DisplayHeatmap"
        name="displayHeatmap"
      /> */}
    </>
  );
};
